export function getCookie(name: string) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");

    if (parts.length === 2) {
        return parts.pop().split(";").shift();
    }
}

export function setCookie(name: string, val: string, days: number = 0) {
    const value = val;

    if (days > 0) {
        // Set it expire in X days
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));

        // Set it
        document.cookie = name + "=" + value + "; expires=" + expires.toUTCString() + "; path=/;samesite=lax";
    } else {
        // Set it
        document.cookie = name + "=" + value + "; path=/;samesite=lax";
    }
}


export function deleteCookie(name: string) {
    const date = new Date();

    // Set it expire in -1 days
    date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));

    // Set it
    document.cookie = name + "=; expires=" + date.toUTCString() + "; path=/";
}